import { Platform } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Box, Divider, HStack, VStack } from 'native-base';

import { Text } from '@pimm/base';
import { SettingsIcon } from '@pimm/base';
import { SiteConfigDto } from '@pimm/services/lib/sms-tenants';
import { useStoreSettings } from '../context/store-settings.context';
import { ReadOnlyField } from './read-only-field';
import Section from './section';

type SiteConfigBlockProps = {
  site: SiteConfigDto;
};

export const SiteConfigBlock = ({ site }: SiteConfigBlockProps) => {
  const { t } = useTranslation();
  const kitchenLayout = useStoreSettings(_ => _.queryKitchenLayout[0].data);

  return (
    <Section.Card variant="form" title={t('store_settings:site_configuration')} icon={<SettingsIcon size={4} color="gray.700" />}>
      <VStack space={4}>
        <HStack space={6} flexWrap="wrap">
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:market')} value={site.configSettings?.marketTitle} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:sms_plan')} value={site.config?.smsPlan} />
          </Box>
          <Box flex={1} minW={170}>
            <ReadOnlyField label={t('store_settings:ops_mode')} value={site.configSettings?.opsModeTitle} />
          </Box>
          <Box flex={1} minW={Platform.OS === 'web' ? undefined : 170} />
        </HStack>

        <HStack space={6} flexWrap="wrap">
          <Box flex={1} minW="170px">
            <ReadOnlyField label={t('store_settings:temperature_unit')} value={site.config?.temperatureUnit} />
          </Box>
          <Box flex={1} minW="170px">
            <ReadOnlyField label={t('store_settings:sales_volume_profile')} value={site.configSettings?.salesVolumeProfile} />
          </Box>
          <Box flex={1} minW={Platform.OS === 'web' ? undefined : 170} />
          <Box flex={1} minW={Platform.OS === 'web' ? undefined : 170} />
        </HStack>

        <Divider />

        <VStack space={2}>
          <Text size="md" fontWeight={600} color="gray.700">
            {t('store_settings:kitchen_configuration')}
          </Text>

          <HStack space={6} flexWrap="wrap">
            <Box flex={1} minW={170}>
              <ReadOnlyField label={t('store_settings:layout_code')} value={kitchenLayout?.code} />
            </Box>
            <Box flex={1} minW={170}>
              <ReadOnlyField label={t('store_settings:layout_title')} value={kitchenLayout?.title} />
            </Box>
            <Box flex={1} minW={170}>
              <ReadOnlyField label={t('store_settings:puw_count')} value={kitchenLayout?.puwCount} />
            </Box>
            <Box flex={1} minW={170}>
              <ReadOnlyField label={t('store_settings:sl_count')} value={kitchenLayout?.slCount} />
            </Box>
          </HStack>
        </VStack>
      </VStack>
    </Section.Card>
  );
};
